import React, {useEffect, useState} from 'react';
import {ISsqDataDocument} from "../../repositories/SsqDataRepository";
import {SsqImages} from "../../images/SsqImages";
import {getHighlightedTextFromHtml} from "../../util/commonUtils";
import clsx from "clsx";
import {AccountService} from "repositories/AccountService";
import {LanguageService} from "language/LanguageService";
import axios from "axios";
import parse from "html-react-parser";
import SimpleUserProfile from "communitypage/common/SimpleUserProfile";
import {langutil} from "language/langutil";
import CommunityPostInfo from "communitypage/common/CommunityPostInfo";
import {IfDocCommentInfo} from "models/IfSsqDataDocCommentEntity";
import {useLoginInfo} from "hooks/useLoginInfo";
import {loginutil} from "util/loginutil";
import {TargetType} from "definitions/TargetType";
import {i18ntrans} from "language/i18nkey";
import {useLoginPopup} from "hooks/useLoginPopup";
import {CommentWrap} from "style/CommonStyledComponents";
import {DocType} from "definitions/DocType";

interface Props {
  accountService?: AccountService;
  ssqDocument: ISsqDataDocument;
  getTranslation: Function;
  languageService: LanguageService;
  clickedTag: Function;
  displayLoginPopup: Function;
  commentList: Array<IfDocCommentInfo>;
}

const BlogDocumentListItem = (props: Props) => {

  const [isEmployee, setIsEmployee] = useState(false);
  const [tags, setTags] = useState([]);
  const {country, lang} = langutil.splitLangCode(props.languageService.lang());
  const [comment, setComment] = useState([]);
  const loginInfo = useLoginInfo();
  const showLoginPopup = useLoginPopup();
  const [checkDate, setCheckDate] = useState(false);

  useEffect(() => {
    setIsEmployee(props.ssqDocument.employ);
    axios.get('/api/guest/ssqData/doctaglist/taggrplist', {
      params: {
        docId: props.ssqDocument.id,
        lang: props.languageService.getLanguage()
      }
    }).then((res) => {
      setTags(res?.data || []);
    });

    axios.get('/api/guest/ssqData/doccomment/list', {
      params: {docId: props.ssqDocument.id}
    }).then((res) => {
      setComment(res?.data || []);
    });
  }, []);

  const t = i18ntrans.common;
  const getTranslation = (key: string) => {
    props.languageService.setNamespace("I18N_NAMESPACE_COMMUNITY_PAGE");
    return props.languageService.getTranslationByKey(key) || "";
  };

  //14일 이전 날짜 계산
  const checkNewDoc = () => {
    const nowDate = new Date(); // 오늘
    const formatDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);

    const beforeDay = formatDate.getTime() - 1209600000; // 오늘날짜 - 14일
    const dbDate = new Date(props.ssqDocument.updateTime);

    const isWithIn14 = dbDate.getTime() >= beforeDay;
    return setCheckDate(isWithIn14);
  };

  useEffect(() => {
    checkNewDoc();
  }, []);

  return (
    <li onClick={(e) => {
      console.log("=================", e);
      e.stopPropagation();
      e.preventDefault();

      if (!loginutil.hasDocViewAuth(loginInfo, props.ssqDocument.displayTarget)) {
        if (loginutil.islogin(loginInfo)) {
          loginutil.alertDocView(loginInfo, props.ssqDocument.displayTarget);
        } else {
          showLoginPopup(true);
        }
        return;
      }

      window.open(props.ssqDocument.docType == "RND_NOTI" ? `/${country}/${lang}/community/rnd/notice/document/${props.ssqDocument.id}`
        : props.ssqDocument.docType == "PARTNER_NOTI" ? `/${country}/${lang}/community/partner/notice/document/${props.ssqDocument.id}` :
          `/${country}/${lang}/community/blog/document/${props.ssqDocument.id}`, "_blank");
    }}>

      <div className="write-body">
        <div className="tag">
          <span
            className="post-kind">{["RND_NOTI", "PARTNER_NOTI"].includes(props.ssqDocument.docType) ? props.getTranslation('I18N_COMMUNITY_RND_NOTICE') :
            ["APPLICATION_NOTE", "TECH_GENERAL", "TECHNICAL_GUIDE"].includes(props.ssqDocument.docType) ?
              props.getTranslation(`I18N_COMMUNITY_BLOG_SELECT_${props.ssqDocument.docType}`) : "'"}</span>
          {tags.map((tag, index) => (
            <span key={index} onClick={(e) => {
              e.stopPropagation();
              props.clickedTag(tag.tag);
            }}>#{tag?.tag}</span>
          ))}
        </div>
        <div className="blog-title">
          <p className="write-title">
            {parse(getHighlightedTextFromHtml(props.ssqDocument.docTitle))}
            {![DocType.RND_NOTI].includes(props.ssqDocument.docType) && props.ssqDocument.displayTarget == 20 &&
              <span className={clsx("lv-info", "lv-worker")}>{props.getTranslation("I18N_SOLUTION_EMPLOYEE_ONLY")}</span>}
            {!["PARTNER_NOTI"].includes(props.ssqDocument.docType) && props.ssqDocument.displayTarget == TargetType.PARTNER &&
              <span className={clsx("lv-info", "partner-level")}>{t("I18N_COMMON_PARTNER_ONLY")}</span>}
            {(props.ssqDocument.docType === "RND_NOTI" && checkDate == true) && <span className={"new"} style={{marginLeft: "1rem"}}>
              <img alt={"new.svg"} src={SsqImages.common.icon.newMark()}/>
            </span>}
            {(props.ssqDocument.docType === "PARTNER_NOTI" && checkDate == true) && <span className={"new"} style={{marginLeft: "1rem"}}>
              <img alt={"new.svg"} src={SsqImages.common.icon.newMark()}/>
            </span>}
          </p>
        </div>

        <div className="blog-content">
          {props.ssqDocument.imageUrl && <div className={"blog-mobile-img"}>
            <img alt={'blog-img-url'}
              src={`/uploads/${props.ssqDocument.imageUrl}`}
              onError={(e: any) => {
                e.target.src = SsqImages.common.icon.noImage();
                e.target.className = "no-image";
                e.target.alt = "no_image.svg";
              }}
            />
          </div>}

          <div className={"blog-content-item"}>
            <p className={"write-content"} onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              if (!loginutil.hasDocViewAuth(loginInfo, props.ssqDocument.displayTarget)) {
                if (loginutil.islogin(loginInfo)) {
                  loginutil.alertDocView(loginInfo, props.ssqDocument.displayTarget);
                } else {
                  showLoginPopup(true);
                }
                return;
              }

              window.open(props.ssqDocument.docType == "RND_NOTI" ? `/${country}/${lang}/community/rnd/notice/document/${props.ssqDocument.id}`
                : props.ssqDocument.docType == "PARTNER_NOTI" ? `/${country}/${lang}/community/partner/notice/document/${props.ssqDocument.id}` :
                  `/${country}/${lang}/community/blog/document/${props.ssqDocument.id}`, "_blank");
            }}>
              {parse(getHighlightedTextFromHtml(props.ssqDocument.description))}</p>

            <CommentWrap>
              <div onClick={(e) => {
                e.stopPropagation();
              }}>
                <SimpleUserProfile userId={props.ssqDocument.lastModifierId}
                  displayLoginPopup={props.displayLoginPopup}
                  askUrl={props.ssqDocument.docType == "RND_NOTI" ?
                    `${window.location.protocol}//${window.location.host}/${country}/${lang}/community/rnd/notice/document/${props.ssqDocument.id}`
                    : props.ssqDocument.docType == "PARTNER_NOTI" ?
                      `${window.location.protocol}//${window.location.host}/${country}/${lang}/community/partner/notice/document/${props.ssqDocument.id}`
                      : `${window.location.protocol}//${window.location.host}/${country}/${lang}/community/blog/document/${props.ssqDocument.id}`}/>
              </div>
              <CommunityPostInfo type={"list"}
                commentList={comment}
                ssqDocument={props.ssqDocument}
                time={props.ssqDocument.updateTime}
                count={props.ssqDocument.clickCount}
                good={props.ssqDocument.goodCount}
                bad={props.ssqDocument.badCount}></CommunityPostInfo>
            </CommentWrap>

          </div>
        </div>
      </div>

      {props.ssqDocument.imageUrl && <div className={"blog-img"}
        style={{
          backgroundSize: "contain", backgroundColor: "#f6f8fb", backgroundRepeat: "no-repeat", backgroundPosition: "center",
          backgroundImage: `url(${`/uploads/${props.ssqDocument.imageUrl}`})`
        }}
      >
      </div>}
    </li>


  );
};


export default BlogDocumentListItem;
